<template>
  <section class="solutions" id="soluciones">
    <div class="content">
      <div class="header-section">
        <div class="intro-text">
          <p>
            Conjunto de soluciones de identificación inteligente que permiten acceder de forma rápida a información
            esencial en situaciones de emergencia mediante tecnología NFC y códigos QR.
          </p>
        </div>

        <div class="title">
          <span class="light">NUESTRAS</span>
          <br />
          <span class="bold">SOLUCIONES</span>
        </div>
      </div>

      <div class="solutions-carousel">
        <button
          class="carousel-arrow carousel-arrow--left"
          type="button"
          aria-label="Ver solución anterior"
          @click="scrollSolutions('left')"
        >
          ‹
        </button>

        <div class="solutions-grid" ref="solutionsTrack">
          <article class="solution-card">
            <div class="solution-icon">
              <img src="../assets/IMG/Sport.png" alt="NFCare" />
            </div>
            <h2>NFCare</h2>
            <p>Pulsera con NFC y QR para
acceder a información médica 
</p>
            <button class="btn-acceder" @click="goToNFCare">ACCEDER</button>
          </article>

          <article class="solution-card">
            <div class="solution-icon">
              <img src="../assets/IMG/Pet.png" alt="KIDS" />
            </div>
            <h2>PET</h2>
            <p>Collar con NFC, QR y AirTag
para identificar y localizar
mascotas</p>
            <a class="btn-acceder" href="https://mypetcare.com.co/dist/" target="_blank" rel="noopener">ACCEDER</a>
          </article>

          <article class="solution-card">
            <div class="solution-icon">
              <img src="../assets/IMG/Mycard.png" alt="MY CARD" />
            </div>
            <h2>MY CARD</h2>
            <p>Tarjeta con NFC y QR para acceso  a tu información profesional</p>
            <button class="btn-acceder" @click="goToMyCard">ACCEDER</button>
          </article>

          <article class="solution-card">
            <div class="solution-icon">
              <img src="../assets/IMG/Kid.png" alt="SPORT" />
            </div>
            <h2>KIDS</h2>
            <p>Pulsera con NFC y QR para
emergencias en actividad
física.<br></p>
            <button class="btn-acceder">ACCEDER</button>
          </article>
        </div>

        <button
          class="carousel-arrow carousel-arrow--right"
          type="button"
          aria-label="Ver siguiente solución"
          @click="scrollSolutions('right')"
        >
          ›
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SolutionsView",
  methods: {
    scrollSolutions(direction) {
      const track = this.$refs.solutionsTrack;
      if (!track) return;

      const cards = track.querySelectorAll(".solution-card");
      if (!cards.length) return;

      const gap = parseFloat(window.getComputedStyle(track).gap || "14") || 14;
      const step = cards[0].offsetWidth + gap;
      const delta = direction === "left" ? -step : step;
      track.scrollBy({ left: delta, behavior: "smooth" });
    },
    goToNFCare() {
      window.location.href = "https://nfcare.com.co/dist/#/";
    },
    goToMyCard() {
      window.open("https://mycard.com.co/", "_blank", "noopener,noreferrer");
    },
  },
};
</script>


<style scoped>
.solutions {
  position: relative;
  background-color: #111;
  margin: 0;
  padding: 64px 0 84px;
  scroll-margin-top: 100px;
  overflow: hidden;
}

.content {
  position: relative;
  z-index: 2;
  width: min(1320px, 94%);
  margin: 0 auto;
}

.header-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(24px, 3.5vw, 54px);
  align-items: start;
  margin-bottom: 18px;
}

.intro-text p {
  font-family: "Barlow", sans-serif;
  color: #ffffff;
  font-size: clamp(16px, 1.4vw, 28px);
  font-weight: 400;
  line-height: 1.22;
  margin: 6px 0 0;
  max-width: 720px;
}

.title {
  margin: 0;
  text-align: right;
  color: #c8f34b;
  font-family: "Barlow", sans-serif;
  font-size: clamp(38px, 4.8vw, 74px);
  font-weight: 600;
  line-height: 0.88;
}

.title .light {
  font-weight: 500;
  color: #c8f34b;
}

.title .bold {
  font-family: "Barlow", sans-serif;
  font-weight: 650;
  letter-spacing: 0.03em;
}

.solutions-carousel {
  position: relative;
}

.solutions-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: clamp(18px, 2vw, 32px);
  align-items: start;
  justify-items: center;
  margin-top: 8px;
}

.carousel-arrow {
  display: none;
}

.solution-card {
  position: relative;
  top: 34px;
  text-align: center;
  width: 100%;
}

.solution-icon {
  width: 100%;
  height: clamp(170px, 14vw, 220px);
  margin: 0 auto 12px;
  border-radius: 14px;
  overflow: hidden;
}

.solution-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 20%;
  border-radius: 14px;
}

.solution-card h2 {
  margin: 14px 0 8px;
  font-family: "Barlow", sans-serif;
  color: #c8f34b;
  font-size: clamp(32px, 2.8vw, 56px);
  font-weight: 600;
  line-height: 1;
}

.solution-card p {
  margin: 0 auto 20px;
  max-width: 310px;
  font-family: "Barlow", sans-serif;
  color: #ffffff;
  font-size: clamp(20px, 1.55vw, 30px);
  font-weight: 400;
  line-height: 1.18;
}

.btn-acceder {
  display: inline-block;
  padding: 10px 24px;
  background-color: #c8f34b;
  color: #111;
  font-family: "Barlow", sans-serif;
  font-size: clamp(18px, 1.2vw, 24px);
  font-weight: 800;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: transform 180ms ease, background-color 180ms ease, color 180ms ease;
  letter-spacing: 0.02em;
  text-decoration: none;
}

.btn-acceder:hover {
  background-color: #c8f34b;
  color: #fff;
  transform: translateY(-2px);
}

@media (min-width: 768px) and (max-width: 1024px) {
  .header-section {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 20px;
  }

  .intro-text p,
  .title {
    text-align: center;
  }

  .solutions-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    margin-top: 8px;
  }

  .solution-card {
    top: 26px;
  }

  .solution-icon {
    height: 210px;
  }
}

@media (max-width: 767px) {
  .solutions {
    padding: 36px 0 54px;
    scroll-margin-top: 40px;
  }

  .content {
    width: min(980px, 92%);
  }

  .header-section {
    grid-template-columns: 1fr;
    gap: 10px;
    margin-bottom: 18px;
  }

  .intro-text p,
  .title {
    text-align: center;
  }

  .title {
    font-size: clamp(40px, 11vw, 66px);
  }

  .solutions-carousel {
    padding: 0 52px;
  }

  .solutions-grid {
    display: flex;
    gap: 14px;
    margin-top: 8px;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    scroll-padding-inline: 0;
    -webkit-overflow-scrolling: touch;
    padding: 2px 0 12px;
  }

  .solutions-grid::-webkit-scrollbar {
    display: none;
  }

  .carousel-arrow {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 64px;
    height: 82px;
    background: transparent;
    color: #004b5c;
    font-family: "Barlow", sans-serif;
    font-size: 48px;
    font-weight: 700;
    line-height: 1;
    border: none;
    cursor: pointer;
    z-index: 4;
    padding: 0;
  }

  .carousel-arrow--left {
    left: 0;
  }

  .carousel-arrow--right {
    right: 0;
  }

  .solution-card {
    top: 12px;
    flex: 0 0 100%;
    max-width: 100%;
    scroll-snap-align: center;
  }

  .solution-icon {
    height: 190px;
  }

  .solution-card h2 {
    font-size: clamp(30px, 8vw, 44px);
  }

  .solution-card p {
    font-size: clamp(18px, 4.7vw, 24px);
  }
}

@media (max-width: 420px) {
  .solutions-carousel {
    padding: 0 42px;
  }

  .carousel-arrow {
    width: 54px;
    height: 70px;
    font-size: 40px;
  }

  .solution-card {
    flex-basis: 100%;
    max-width: 100%;
  }

  .solution-icon {
    height: 210px;
  }
}
</style>